import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlobRoutingModule } from './blob-routing.module';
import { BlobComponent } from './blob.component';
import { BlobDetailsComponent } from './blob-details/blob-details.component';
import { BlobListComponent } from './blob-list/blob-list.component';
import { PipeCustomModule } from 'my-lib-sanfelici';
import { BlobSharedModule } from './blob-shared/blob-shared.module';
import { MyCustomMaterialModule } from 'san-common';




@NgModule({
  imports: [
    CommonModule,
    MyCustomMaterialModule,
    BlobRoutingModule,PipeCustomModule,BlobSharedModule,MyCustomMaterialModule

  ],
  declarations: [BlobComponent,BlobDetailsComponent,BlobListComponent],
  exports: [BlobComponent,BlobDetailsComponent,BlobListComponent]
})
export class BlobModule { }
